// Utilities
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
import { lazy } from "react";
export const ClearRecurrenceFromDueDateRemovalDialogContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-clearrecurrencefromduedateremovaldialog" */ "./ClearRecurrenceFromDueDateRemovalDialogContainer")).then((bundle)=>{
        return {
            default: bundle.ClearRecurrenceFromDueDateRemovalDialogContainer
        };
    });
export const LazyClearRecurrenceFromDueDateRemovalDialogContainer = /*#__PURE__*/ lazy(ClearRecurrenceFromDueDateRemovalDialogContainerLazyLoader);
